export default "__VITE_ASSET__DroOcIEO__"